export const articleMarketplaces = {
  TWO_DAY_PART: '2dayparts.com',
  COOL_COILOVERS: 'coolcoilovers',
};

export const articleMarketplacesList = [
  { label: articleMarketplaces.TWO_DAY_PART, value: articleMarketplaces.TWO_DAY_PART },
  { label: articleMarketplaces.COOL_COILOVERS, value: articleMarketplaces.COOL_COILOVERS },
];
